{
  "collapse": "Свернуть",
  "expand": "Развернуть"
}
